import { memo } from 'react';
import { Settings } from 'lucide-react';
import { useCookieConsent } from '@/hooks/useCookieConsent';

interface CookieSettingsButtonProps {
  className?: string;
}

const CookieSettingsButton = memo(function CookieSettingsButton({ className }: CookieSettingsButtonProps) {
  const { openSettings } = useCookieConsent();
  
  return (
    <button
      onClick={openSettings}
      className={className}
      aria-label="Öppna cookieinställningar"
    >
      <span className="inline-flex items-center gap-1.5">
        <Settings className="w-3 h-3" />
        Cookieinställningar
      </span>
    </button>
  );
});

export default CookieSettingsButton;
